import { render } from "./MctTree.vue?vue&type=template&id=84dd038a"
import script from "./MctTree.vue?vue&type=script&lang=js"
export * from "./MctTree.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__